import { useTrueAtMediaBreakpointLessThen } from '@costar-ui/hooks'

export const useIsMobileView = () => {
  return useTrueAtMediaBreakpointLessThen('650px')
}
